import '@progress/kendo-theme-default/dist/all.css';

import React, { useMemo, useState} from "react";
import LinkButton from "../../../components/common/link/LinkButton";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import { FieldWrapper } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";

import InnerPanel from './InnerPanel';

import ActionButtons from '../../../components/common/buttons/ActionButtons';

import {
    Checkbox,
    TextArea,
  } from "@progress/kendo-react-inputs";

import {ROUTE_SKILL_SCHEDULER} from "../../../constants/routeConstants";
import ContentWrapper from '../../../components/common/wrapper/ContentWrapper';

import styles from "../schedulePageStyles.module.css"
import marginStyles from "../../../styles/marginstyles.module.css"
import gridStyles from "../../../styles/gridstyles.module.css"

import ClearFix from '../../../components/common/ClearFix';
import ScheduleFormPart from './schedule/ScheduleFormPart';

import { useNavigate } from 'react-router-dom';
import ReverseScheduleFormPart from './schedule/ReverseScheduleFormPart';
import AgentFormPart from './agents/AgentFormPart';
import SkillLevelFormPart from './skills/SkillLevelFormPart';
import { SkillLevelsUserSet } from '../../../model/SkillScheduleModel';
import ValidatedInput from '../../../components/validation/ValidatedInput';
import { FIELD_GENERAL, FIELD_NAMES_REV_SCH, FIELD_NAMES_SCH, FIELD_SCH_NAME } from '../../../validation/SkillSchedulerValidation';
import ValidationField from '../../../components/validation/ValidationField';


const InnerSkillScheduleForm = props => {
    const {isCreate} = props;
    const {onSave, onCancel, onReload, onChange} = props;
    const {skillSchedule} = props;
    const {validationState} = props;
    const navigate = useNavigate();

    const [expandedState, setExpandedState] = useState([panelIds.schedule]);
    const expandAll = !!validationState && validationState.active; 

    console.log("InnerSkillScheduleForm")
    console.log(JSON.stringify(skillSchedule))
    
    const userSet = useMemo(() => {
        if (!skillSchedule) return [];
        if (!skillSchedule.body) return [];
        if (!skillSchedule.body.length) return [];

        const body = skillSchedule.body[0];
        if (!body) return [];
        if (!body.userSet) return [];
        return body.userSet;
    }, [skillSchedule]);

    const skillLevelSet = useMemo(() => {
        if (!skillSchedule) return [];
        if (!skillSchedule.body) return [];
        if (!skillSchedule.body.length) return [];

        const body = skillSchedule.body[0];
        if (!body) return [];
        if (!body.skillSet) return [];
        return body.skillSet;
    }, [skillSchedule])

    /*
    const dispatchWorkingSkillSchedule = useCallback((newWorkingCallerList) => {
        dispatch(callerListActions.setWorkingCallerList({callerList: newWorkingCallerList}));
    }, [dispatch]);*/

    const handleNavigateBack = () => {
        navigate(ROUTE_SKILL_SCHEDULER)
    }

    const handleOnSave = () => {
        if (onSave) onSave();
    }

    const handleOnCancel = () => {
        if (onCancel) onCancel();
    }

    const handleOnReload = () => {
        if (onReload) onReload();
    }

    const handleChange = (field, value) => {
        if (!field) return;
        const newSkillSchedule = {...skillSchedule};
        newSkillSchedule[field] = value;
        if (onChange) onChange(newSkillSchedule);
    }

    const handleScheduleChange = schedule => {
        handleChange("schedule", schedule);
    }

    const handleReverseScheduleChange = schedule => {
        handleChange("reverseSchedule", schedule);
    }

    const handleNameChange = e => {
        handleChange("name", e.value);
    }

    const handleActiveChange = e => {
        handleChange("enabled", e.value);
    }

    const handleDescriptionChange = e => {
        handleChange("description", e.value);
    }

    const handleAgentsChange = newAgents => {
        if (!skillSchedule) return;

        let newSkillLevelUserSet = new SkillLevelsUserSet();

        if (skillSchedule.body && skillSchedule.body.length) {
           const skillLevelUserSet = skillSchedule.body[0];
           if (skillLevelUserSet) newSkillLevelUserSet = {...skillLevelUserSet};
        }

        newSkillLevelUserSet.userSet = newAgents;

        handleChange("body", [newSkillLevelUserSet]);
    }

    const handleSkillLevelsChange = newSkillLevels => {
        if (!skillSchedule) return;
        if (!skillSchedule.body) return;

        let newSkillLevelUserSet = new SkillLevelsUserSet();

        if (skillSchedule.body && skillSchedule.body.length) {
           const skillLevelUserSet = skillSchedule.body[0];
           if (skillLevelUserSet) newSkillLevelUserSet = {...skillLevelUserSet};
        }

        newSkillLevelUserSet.skillSet = newSkillLevels;

        handleChange("body", [newSkillLevelUserSet]);
    }

    const handleSelect = (e) => {
        if (!e) return;
        if (!e.target) return;
        if (!e.target.props) return;
        const id = e.target.props.id;
        if (!id) return;

        setExpandedState((current) => {
            const newState = [...current];
            const idx = current.indexOf(id);

            if (idx === -1) {
                newState.push(id);
            } else {
                newState.splice(idx, 1);
            }

            return newState;
        })
    }

    return (<>
    <ContentWrapper>
        <LinkButton 
            text="Back to list"
            onClick={handleNavigateBack}
        />

        <ValidationField 
            name={FIELD_GENERAL}
            validationState={validationState}
        />

        <section className={`${styles.section}`}>
        <div className={`${marginStyles.mb_10}`}>
            <div className={gridStyles.column_50_no_pad}>
            <FieldWrapper >
                <ValidatedInput
                    label={"Schedule name"}
                    name={FIELD_SCH_NAME}
                    style={{
                    width: "100%",
                    }}
                    //pattern={"[A-Za-z]+"}
                    minLength={2}
                    value={skillSchedule && skillSchedule.name ? skillSchedule.name : ""}
                    type="text"
                    disabled={!isCreate}
                    onChange={handleNameChange}
                    validationState={validationState}
                />
            </FieldWrapper>
            </div>
            <div className={gridStyles.column_50_no_pad} style={{textAlign: "right"}}>
                <Label>&nbsp;</Label><br/>
                <Checkbox  
                    size={"medium"} 
                    rounded={"medium"} 
                    label="Active" 
                    onChange={handleActiveChange}
                    value={!!skillSchedule.enabled}
                />
            </div>
            <ClearFix />
        </div>
        <FieldWrapper>
            <Label>Description</Label>
            <TextArea 
                name="description"
                value={skillSchedule && skillSchedule.description ? skillSchedule.description : ""}
                onChange={handleDescriptionChange}
            />
        </FieldWrapper>

        </section>

        <section className={styles.section} id="schedPanelBarWrapper">
        <PanelBar isControlled={true} expanded={expandAll ? allPanelIds : expandedState} onSelect={handleSelect}>
            <PanelBarItem className={isSelectedClass(expandedState, panelIds.schedule, expandAll)} title="Schedule" id={panelIds.schedule}>
                <InnerPanel>
                    <ScheduleFormPart
                        schedule={skillSchedule ? skillSchedule.schedule : null}
                        onChange={handleScheduleChange}
                        validationState={validationState}
                        names={FIELD_NAMES_SCH}
                    />
                </InnerPanel>
            </PanelBarItem>
            <PanelBarItem className={isSelectedClass(expandedState, panelIds.reverse, expandAll)} title="Reverse schedules" expanded={expandAll} id={panelIds.reverse}>
                <InnerPanel>
                    <ReverseScheduleFormPart 
                        reverseSchedule={skillSchedule ? skillSchedule.reverseSchedule : null}
                        onChange={handleReverseScheduleChange}
                        validationState={validationState}
                        names={FIELD_NAMES_REV_SCH}
                    />
                </InnerPanel>
            </PanelBarItem>
            <PanelBarItem className={isSelectedClass(expandedState, panelIds.skills, expandAll)} title="Skill levels" expanded={expandAll} id={panelIds.skills}>
                <InnerPanel>
                    <SkillLevelFormPart
                        skillLevels={skillLevelSet}
                        onChange={handleSkillLevelsChange}
                        validationState={validationState}
                    />
                </InnerPanel>
            </PanelBarItem>
            <PanelBarItem className={isSelectedClass(expandedState, panelIds.agents, expandAll)} title="Agents" expanded={expandAll} id={panelIds.agents}>
                <InnerPanel>
                    <AgentFormPart 
                        agents={userSet}
                        onChange={handleAgentsChange}
                        validationState={validationState}
                    />
                </InnerPanel>
            </PanelBarItem>
            {false && <PanelBarItem className={isSelectedClass(expandedState, panelIds.groups, expandAll)} title="Groups" expanded={expandAll} id={panelIds.groups}>
                <InnerPanel>
                    put groups here
                </InnerPanel>
            </PanelBarItem>}
        </PanelBar>
        </section>
        <ActionButtons 
            onSave={handleOnSave}
            onCancel={handleOnCancel}
            onReload={handleOnReload}
        />
    </ContentWrapper>
    </>)
}

export default InnerSkillScheduleForm;

const panelIds = {
    schedule: "pnl_schedule",
    agents: "pnl_agents",
    skills: "pnl_skills",
    reverse: "pnl_reverse",
    groups: "pnl_groups"
}

const allPanelIds = Object.entries(panelIds).map(([key, value]) => value);

const isSelected = (selectedState, id, expandAll) => {
    if (expandAll) return true;
    if (!selectedState) return false;
    if (!id) return false;
    return selectedState.includes(id);
}

const isSelectedClass = (selectedState, id, expandAll) => {
    return isSelected(selectedState, id, expandAll) ? "k-force-selected" : "k-force-unselected";
}